jQuery( function ($) {

    $( '.side-heading' ).each( function () {
        $( this ).css( 'min-height', `${ $( '.heading', this ).width() }px` );
    });

});